import { render, staticRenderFns } from "./EditRoomRecord.vue?vue&type=template&id=4af73eea&"
import script from "./EditRoomRecord.vue?vue&type=script&lang=js&"
export * from "./EditRoomRecord.vue?vue&type=script&lang=js&"
import style0 from "./EditRoomRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports